import { createContext } from "react";

export type NotificationContextValue = {
  unreadCount: number;
};

export const NotificationContext = createContext<NotificationContextValue>({
  unreadCount: 0,
});
